import { format } from 'date-fns';
import { z } from 'zod';

export const formSchema = z.object({
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),

  ngay_ct: z.string().optional(),
  ngay_lct: z.string().optional(),
  dien_giai: z.string().optional(),

  transfer_yn: z.boolean().optional(),

  status: z.string().optional(),

  t_ps_no_nt: z.coerce.number().optional(),
  t_ps_co_nt: z.coerce.number().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_nt: '',
  ty_gia: 0,

  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],
  dien_giai: '',

  transfer_yn: false,

  status: '',

  t_ps_no_nt: 0,
  t_ps_co_nt: 0
};

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_kh: z.string().optional(),
  tk: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchSchema = z.infer<typeof searchSchema>;
export type SearchFormValues = SearchSchema;

export const initialSearchParams: SearchSchema = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  dien_giai: '',
  ma_kh: '',
  tk: '',
  ma_unit: '',
  status: '',
  user_id0: ''
};

export const initialSearchValues = initialSearchParams;
